import Div from "@jumbo/shared/Div";
import { capitalizeFLetter } from "@jumbo/utils";
import { nFormatter } from "app/utils/utils";
import React, { useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
  Label,
} from "recharts";

const LineChartReport = ({
  labels,
  xAxislabel,
  yAxislabel,
  graphType,
  graphData,
  defaultLabel,
}) => {
  //console.log("defaultLabel:", defaultLabel);

  let dl =
    defaultLabel != "" && defaultLabel != null && defaultLabel != undefined
      ? defaultLabel
      : "impressions";
  const [barProps, setBarProps] = useState(
    // labels.reduce(
    //   (a, { key }) => {
    //     a[key] = key == "impressions" ? false : true;
    //     return a;
    //   },
    //   { hover: null }
    // )
    Object.keys(labels).reduce(
      (acc, key) => {
        acc[key] = key === dl ? false : true;
        return acc;
      },
      { hover: null }
    )
  );

  //console.log("barProps:", barProps);

  const selectBar = (e) => {
    setBarProps({
      ...barProps,
      [e.dataKey]: !barProps[e.dataKey],
      hover: null,
    });
  };

  return (
    <ResponsiveContainer height={400}>
      <LineChart
        data={graphData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey={graphType}
          axisLine={false}
          tickLine={false}
          angle={graphData.length > 10 ? -45 : 0}
          textAnchor={graphData.length > 10 ? "end" : "middle"}
          interval={0}
        >
          <Label
            value={xAxislabel}
            position="bottom"
            offset={graphData.length > 10 ? 45 : 0}
            //wrapperStyle={{ paddingTop: "50px" }}
          />
        </XAxis>
        <YAxis
          tickFormatter={nFormatter}
          axisLine={false}
          tickLine={false}
          yAxisId="left-axis"
          label={{ value: yAxislabel, angle: -90, position: "insideLeft" }}
        />
        <Tooltip
          content={({ active, label, payload }) => {
            return active ? (
              <Div sx={{ color: "common.white" }}>
                {payload &&
                  payload.length &&
                  payload.map((row, index) => {
                    return (
                      <div
                        key={index}
                        className={index !== payload.length - 1 ? "mb-1" : ""}
                      >
                        <div
                          style={{
                            color: row.color,
                            fontSize: 8,
                            letterSpacing: 2,
                            //textTransform: "uppercase",
                          }}
                        >
                          {row.name}
                        </div>
                        <div
                          style={{
                            color: row.color,
                          }}
                        >
                          {row.value ? nFormatter(row.value, 2) : 0}
                          {/* {row.value} */}
                        </div>
                      </div>
                    );
                  })}
              </Div>
            ) : null;
          }}
          wrapperStyle={{
            background: "white",
            borderRadius: 4,
            padding: "5px 8px",
            fontWeight: 500,
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
        />
        <Legend
          onClick={selectBar}
          align="center"
          verticalAlign="bottom"
          wrapperStyle={{
            paddingTop: graphData.length > 10 ? "60px" : "30px",
            cursor: "pointer",
            //textTransform: "capitalize",
          }}
          //formatter={legendFormatter}
        />

        {Object.keys(labels).map((labelKey, index) => (
          <Line
            key={index}
            yAxisId={labelKey == "spend" ? "right-axis" : "left-axis"}
            type="monotone"
            strokeWidth={2}
            dataKey={labelKey}
            fill={labels[labelKey].color}
            stroke={labels[labelKey].color}
            hide={barProps[labelKey] === true}
            fillOpacity={Number(
              barProps.hover === labelKey || !barProps.hover ? 1 : 0.6
            )}
            name={labels[labelKey].label}
            filter="url(#shadow)"
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LineChartReport;
